import VehicleDetailsBubble from './VehicleDetailsBubble';

export default VehicleDetailsBubble;
